import React from "react"
import FooterMainNav from "./nav/FooterMainNav"

function Footer() {
  return (
    <footer className="bg-blue-dark">
      <FooterMainNav />

      <p className="text-center w-full block text-white py-4 px-4 text-sm mb-0">
        © {new Date().getFullYear()}
        {` `}
        Mitchells & Butlers The Dining Out Card
      </p>
    </footer>
  )
}

export default Footer
